<template>
  <div id="app" :key="appKey">
    <router-view/>
  </div>
</template>

<script>

export default {
  data() {
    return {
      appKey: 1
    }
  },
  watch: {
    // // 二级路由路由跳转视图切换
    // '$route': function (newUrl, oldUrl) {
    //   this.appKey = new Date().getTime()
    // }
  }
}
</script>

<style>
.navMask {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1;
}
</style>